<div v-if="shouldRenderConfig" v-bind:class="getClassName">
    <div v-if="getWebProductEnableTemplateChooser">
        <Select2
            v-model="value"
            :options="options"
            :settings="settings"
        />        
    </div>
    <button type="button" class="btn btn-primary" ref="personalizeBtn" v-bind:class="getDisableClass" v-on:click="onClickPersonalize()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-6 w-6 border-current inline" width="25" height="25">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path>
        </svg>
        <span>{{ $t('Personalize') }}</span>
    </button>    
</div>

